import React, { useEffect, useState } from "react";
import styles from "./statistics-overview.module.css";
import StatisticsCard from "../../../../../components/statistics-card/statistics-card";

const ClassesStatisticsOverview = ({ institutionOverview }) => {
  const [overviewStatistics, setOverviewStatistics] = useState({});

  const fetchClassStatistics = async (data) => {
    setTimeout(() => {
      setOverviewStatistics({
        total_classes: data?.total_classes,
        total_sections: data?.total_sections,
        total_teachers: data?.total_teachers,
        total_students: data?.total_students,
      });
    }, 3000);
  };

  useEffect(() => {
    if (institutionOverview) {
      fetchClassStatistics(institutionOverview);
    }
  }, [institutionOverview]);

  const overview_statistics = [
    {
      icon_name: "clipboard",
      icon_fill: "transparent",
      icon_stroke: "#ffffff",
      icon_width: "24px",
      icon_height: "24px",
      heading_text: "Total Classes",
      card_bg_color: "rgba(231, 248, 255, 1)",
      icon_container_bg_color: "rgba(75, 202, 255, 1)",
      statistic_value: overviewStatistics?.total_classes ?? "-",
    },
    {
      icon_name: "section",
      icon_fill: "transparent",
      icon_stroke: "#ffffff",
      icon_width: "24px",
      icon_height: "24px",
      heading_text: "Total Sections",
      card_bg_color: "rgba(242, 255, 244, 1)",
      icon_container_bg_color: "rgba(41, 194, 65, 1)",
      statistic_value: overviewStatistics?.total_sections ?? "-",
    },

    {
      icon_name: "users-icon",
      icon_fill: "transparent",
      icon_stroke: "#ffffff",
      icon_width: "24px",
      icon_height: "24px",
      heading_text: "Total Teachers",
      card_bg_color: "rgba(255, 251, 233, 1)",
      icon_container_bg_color: "rgba(235, 206, 61, 1)",
      statistic_value: overviewStatistics?.total_teachers ?? "-",
    },
    {
      icon_name: "graduation-hat-icon",
      icon_fill: "transparent",
      icon_stroke: "#ffffff",
      icon_width: "24px",
      icon_height: "24px",
      heading_text: "Total Students",
      card_bg_color: "rgba(255, 243, 238, 1)",
      icon_container_bg_color: "rgba(224, 90, 33, 1)",
      statistic_value: overviewStatistics?.total_students ?? "-",
    },
  ];

  return (
    <div className={styles.statistics_overview}>
      <div className={styles.statistics}>
        {overview_statistics?.map(
          ({
            icon_name,
            icon_fill,
            icon_stroke,
            icon_width,
            icon_height,
            heading_text,
            card_bg_color,
            icon_container_bg_color,
            statistic_value,
          }) => (
            <div className={styles.statistics_card}>
              <StatisticsCard
                icon_name={icon_name}
                icon_fill={icon_fill}
                icon_stroke={icon_stroke}
                icon_width={icon_width}
                icon_height={icon_height}
                heading_text={heading_text}
                card_bg_color={card_bg_color}
                icon_container_bg_color={icon_container_bg_color}
                statistic_value={statistic_value}
              />
            </div>
          )
        )}
      </div>
    </div>
  );
};

export default ClassesStatisticsOverview;
